module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_15-5c1cb3df23d820ab205b142e95a487d8.jpg";